module.exports = __webpack_public_path__ + "static/track-share-712ae675095589213536b1578f445a3f.svg";